import React from "react";
import PropTypes from "prop-types";
import CollectionLink from "../../utils/generate-collection-link";
import CollectionTitle from "../../atoms/CollectionTitle";
import styles from "./styles.m.css";
import { getStoryHeadline } from "../../utils/utils";
import Icon from "../../atoms/icon";
import StoryCardVertical from "../../atoms/story-card-vertical";
import BigStoryCardCurve from "../../atoms/big-story-card-curve";
import SmallStoryCard from "../../atoms/small-story-card";
import ElectionMapComponent from "../../pages/vikatan-election-map";
import ConstituencyDirectSearch from "../../atoms/constituency-direct-search";

const EightStoryCollectionWithMap = ({
  collection,
  accentColor,
  authorName = true,
  utmURL = "",
  homecollection = false,
  storyLimit,
  textOverleyCard
}) => {
  const { name, items } = collection;

  // Only 8 stories
  const effectiveStoryLimit = 10;

  const stories =
    items
      .filter(({ story = {} }) => getStoryHeadline(story) && story.url)
      .slice(0, effectiveStoryLimit)
      .map(({ story }) => story) || [];

  if (!stories.length) {
    return null;
  }

  const bigStories = stories.slice(0, 2); // 2 big stories
  const smallStories = stories.slice(2, 10); // 6 small stories

  return (
    <div
      className={`container ${styles["collection-wrapper"]} ${
        homecollection ? styles["home-card"] : styles["not-home-card"]
      }`}
    >
      <div className={styles["left-section"]}>
        <CollectionLink collection={collection} disableAppSlugCheck={true} className={`${styles["title-grid"]}`}>
          <div className={styles["title-container"]}>
            <CollectionTitle className={styles.title} title={name} />
            <Icon type="slider-next" className={styles["arrow-icon"]} />
          </div>
        </CollectionLink>

        {/* New Design for 8 stories */}
        <div className={styles["stories-content"]}>
          {bigStories.map((story, index) => (
            <div key={story.id} className={styles["column"]}>
              <BigStoryCardCurve
                story={story}
                className={styles["big-story-card"]}
                bigimage={index === 0} // First one is big image
                videocard={true}
                textOverleyCard={true}
                pFrom="eight-stories-map"
              />
              <div className={styles["small-stories-list"]}>
                {smallStories.slice(index * 4, (index + 1) * 4).map(smallStory => (
                  <SmallStoryCard key={smallStory.id} story={smallStory} className={styles["small-story-card"]} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles["right-section"]}>
        {/* Ad slot removed */}
        <div className={styles["map-widget"]}>
          <h3 className={styles["map-header"]}>
            <span>தொகுதி 360</span>
          </h3>
          <div className={styles["map-subtext"]}>தேர்தல் கள நிலவரங்களை அறிந்துகொள்ள</div>
          <ElectionMapComponent />
          <div className={styles["or-divider"]}>
            <span className={styles["or-line"]} />
            <span className={styles["or-text"]}>OR</span>
            <span className={styles["or-line"]} />
          </div>
          <div className={styles["search-widget"]}>
            <div className={styles["search-box"]}>
              <ConstituencyDirectSearch />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

EightStoryCollectionWithMap.propTypes = {
  accentColor: PropTypes.string,
  authorName: PropTypes.bool,
  utmURL: PropTypes.string,
  homecollection: PropTypes.bool,
  storyLimit: PropTypes.number,
  openInNewTab: PropTypes.bool,
  textOverleyCard: PropTypes.bool,
  collection: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
    slug: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(StoryCardVertical.propTypes))
  })
};
EightStoryCollectionWithMap.storyLimit = 8;

export default EightStoryCollectionWithMap;
